export const generateLinkToEms = (eid: string | number, locationId: string | number) => {
    let preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language

    return `https://ems.peie.om/RegistrationStart.aspx?eid=${eid}&location_id=${locationId}&lang=${preferredLanguage ? preferredLanguage : "en-US"} `
}